import { graphql } from "gatsby"
import PropTypes from "prop-types"
import Img from "components/Img"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

function DashboardLogo({ label, heading, description, logos }) {
  return (
    <Container section margin>
      <Heading
        label={label}
        title={heading}
        subtitle={description}
        decoration="line"
      />
      {logos && (
        <div className="mt-16 flex flex-wrap items-center justify-around">
          {logos.map((logo) => (
            <div key={logo.id}>
              {/* Handle both Gatsby processed images and local static paths */}
              {logo.gatsbyImageData ? (
                <Img image={logo} alt={logo.title} className="mx-4 mb-7" />
              ) : (
                <img
                  src={logo.url}
                  alt={logo.title || ""}
                  className="mx-4 mb-7"
                  style={{ height: 48, objectFit: "contain" }}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </Container>
  )
}

DashboardLogo.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  logos: PropTypes.arrayOf(PropTypes.shape({})),
}

export default DashboardLogo

export const query = graphql`
  fragment DashboardLogo on ContentfulDashboardLogo {
    id
    __typename
    label
    heading
    description
    logos {
      id
      title
      gatsbyImageData(quality: 100, height: 48, layout: FIXED)
    }
  }
`
